export const MESSAGE_KEY_PATTERN = /^productPage\./;

// Sections never sent through Velo/AI personalization — legal/compliance
// disclaimer text must not be rewritten, for any product.
export const EXCLUDED_PERSONALIZATION_SECTIONS = new Set(['footnotes']);

// Object keys skipped while walking config — buy-box fine print / legal notes
export const EXCLUDED_PERSONALIZATION_OBJECT_KEYS = new Set(['note']);

// Mirrors assistant-api's productPagePersonalizationSchema `copy` field maxLength — an
// item longer than this is left out of the personalization request entirely (falls back
// to its own default copy) rather than sent truncated. Keep in sync with
// server/api/product-page/schemas/personalization.js in that repo.
export const MAX_PERSONALIZATION_COPY_LENGTH = 2500;
